const UserView = (): JSX.Element => {
  return <></>
}
export default UserView
